export enum PROVIDERS {
	YOUTUBE = 'youtube',
	OPENTOK = 'opentok',
	HTML5 = 'html5'
}
